if (!customElements.get('quick-add')) {
  class QuickAdd extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.inStockIcon = '';
      this.outOfStockIcon = '';
      this.priceOriginalHtml = '';
      this.inventoryOriginalHtml = '';
      this.priceUnit = '';
      this.jsonInventory = {};

      const inStockIcon = document.querySelector('#in-stock-icon-markup');
      const outOfStockIcon = document.querySelector('#out-of-stock-icon-markup');

      if (inStockIcon) {
        this.inStockIcon = inStockIcon.innerHTML;
      }

      if (outOfStockIcon) {
        this.outOfStockIcon = outOfStockIcon.innerHTML;
      }

      if (this.productForm) {
        this.productId = this.productForm.querySelector('[name="product-id"]').value;
        this.productForm.addEventListener('change', this.handleChange.bind(this));
        this.submitButton = this.productForm.querySelector('[type="submit"]');

        const priceEl = document.querySelector(`[data-quick-add-price="${this.productId}"]`);
        const inventoryEl = document.querySelector(`[data-quick-add-inventory="${this.productId}"]`);

        if (priceEl) {
          const priceUnitEl = priceEl.querySelector('.unit');
          if (priceUnitEl) {
            this.priceUnit = priceUnitEl.innerHTML;
          }
          this.priceOriginalHtml = priceEl.innerHTML;
        }

        if (inventoryEl) {
          this.inventoryOriginalHtml = inventoryEl.innerHTML;

          //check if there's a json script with more accurate inventory details
          const inventoryJsonEl = this.querySelector(`#quick-add-inventory-json-${this.productId}`);
          if (inventoryJsonEl) {
            const jsonData = JSON.parse(inventoryJsonEl.innerHTML);
            const variantId = this.productForm.querySelector('[name="id"]').value;
            this.jsonInventory = jsonData;
            let totalQty = 0,
              shipQty = 0,
              pickupQty = 0,
              inventoryMarkup = '';
            jsonData.forEach((entry) => {
              const locationQty = parseInt(entry.quantity, 10);
              totalQty += locationQty;

              if (entry.location && window.apexShipFromLocationIds.includes(entry.location.id)) {
                shipQty += locationQty;
              } else {
                pickupQty += locationQty;
              }
            });

            if (totalQty > 0) {
              let inventoryLinkText = window.fulfillmentStrings.shippingAndPickupAbbr;

              if (shipQty === 0) {
                inventoryLinkText = window.fulfillmentStrings.onlyPickupAbbr;
              } else if (pickupQty === 0) {
                inventoryLinkText = window.fulfillmentStrings.onlyShippingAbbr;
              }

              inventoryMarkup = ` 
                <quick-add-show-inventory data-variant-id="${variantId}">
                  <button
                    type="button"
                    class="group cursor-pointer flex items-center text-left flex-wrap">
                    <span class="flex items-center">
                      ${this.inStockIcon}
                      ${totalQty.toLocaleString('en-US')} in stock
                    </span>
                    <span class="px-1">|</span>
                    <span
                      class="
                        font-bold text-primary-500 group-hover:text-primary-600 group-focus:text-primary-600
                        group-hover:underline group-focus:underline">${inventoryLinkText}</span>
                  </button>
                </quick-add-show-inventory>`;
            } else {
              inventoryMarkup = `${this.outOfStockIcon} <span>${window.fulfillmentStrings.outOfStock}</span>`;
            }

            inventoryEl.innerHTML = inventoryMarkup;
          } else {
            this.jsonInventory = null;
          }
        }
      }
    }

    handleChange() {
      const variantId = this.productForm.querySelector('[name="id"]').value;
      const variantOption = this.productForm.querySelector(`option[value="${variantId}"]`);

      if (variantId) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.removeAttribute('disabled');
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('disabled', true);
      }

      if (!variantOption) return;

      const price = variantOption.dataset.price ? parseInt(variantOption.dataset.price, 10) * 0.01 : null;
      let priceMarkup = '';
      const priceElements = document.querySelectorAll(`[data-quick-add-price="${this.productId}"]`);
      const skuElements = document.querySelectorAll(`[data-quick-add-sku="${this.productId}"]`);
      const brandElements = document.querySelectorAll(`[data-quick-add-brand="${this.productId}"]`);
      const manuElements = document.querySelectorAll(`[data-quick-add-manu="${this.productId}"]`);

      if (price !== null) {
        if (price > 0) {
          priceMarkup = `$${price.toFixed(2)}`;
          if (this.priceUnit) {
            priceMarkup = `${priceMarkup}/<span class="unit">${this.priceUnit}</span>`;
          }
        } else {
          priceMarkup = 'Price not found';
        }
      } else {
        priceMarkup = this.priceOriginalHtml;
      }

      priceElements.forEach((element) => {
        const apexPriceEl = element.querySelector('apex-price');
        if (apexPriceEl) {
          if (price !== null) {
            if (price > 0) {
              apexPriceEl.updatePrice(price * 100);
              apexPriceEl.toggleVariantSelection(true);
            } else {
              apexPriceEl.toggleVariantSelection(false);
              //element.innerHTML = 'Price not found';
            }
          } else {
            element.innerHTML = this.priceOriginalHtml;
          }
        } else {
          priceMarkup;
        }
      });
      const sku = variantOption.dataset.sku ? variantOption.dataset.sku : '';
      skuElements.forEach((element) => {
        element.innerHTML = sku;
      });

      const manu = variantOption.dataset.manu ? variantOption.dataset.manu : '';
      manuElements.forEach((element) => {
        element.innerHTML = manu;
      });

      const imageSrc = variantOption.dataset.image.trim() ? variantOption.dataset.image : '';
      const imageElements = document.querySelectorAll(`[data-quick-add-image="${this.productId}"]`);
      imageElements.forEach((element) => {
        const image = element.querySelector('img');
        if (!imageSrc && element.dataset.defaultImage) {
          image.src = element.dataset.defaultImage;
          return;
        } else if (imageSrc != '') {
          image.src = imageSrc;
          //delete the srcset attr and sizes
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
      });

      const brand = variantOption.dataset.brand ? variantOption.dataset.brand : '';
      const brandUrl = variantOption.dataset.brandUrl ? variantOption.dataset.brandUrl : '';
      brandElements.forEach((element) => {
        if (brand === '') {
          element.classList.add('hidden');
          //look for a previous sibling with class .sku-brand-divider and hide it
          const divider = element.previousElementSibling;
          if (divider && divider.classList.contains('sku-brand-divider')) {
            divider.classList.add('hidden');
          }
          return;
        }
        const divider = element.previousElementSibling;
        if (divider && divider.classList.contains('sku-brand-divider')) {
          divider.classList.remove('hidden');
        }
        element.classList.remove('hidden');
        element.innerHTML = brand;
        element.setAttribute('href', brandUrl);
      });

      let rootUrl = Shopify.routes.root;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantInventoryUrl = `${rootUrl}variants/${variantId}/?section_id=quick-add-inventory`;

      const inventoryElements = document.querySelectorAll(`[data-quick-add-inventory="${this.productId}"]`);
      let inventoryMarkup = '';

      inventoryElements.forEach((element) => {
        element.innerHTML = 'Loading&hellip;';
      });

      fetch(variantInventoryUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
          const scriptTag = sectionInnerHTML.querySelector('script');
          if (scriptTag) {
            const jsonData = JSON.parse(scriptTag.innerHTML);
            if (jsonData) {
              this.jsonInventory = jsonData;
              let totalQty = 0,
                shipQty = 0,
                pickupQty = 0;
              jsonData.forEach((entry) => {
                const locationQty = parseInt(entry.quantity, 10);
                totalQty += locationQty;

                if (entry.location && window.apexShipFromLocationIds.includes(entry.location.id)) {
                  shipQty += locationQty;
                } else {
                  pickupQty += locationQty;
                }
              });

              if (totalQty > 0) {
                let inventoryLinkText = window.fulfillmentStrings.shippingAndPickupAbbr;

                if (shipQty === 0) {
                  inventoryLinkText = window.fulfillmentStrings.onlyPickupAbbr;
                } else if (pickupQty === 0) {
                  inventoryLinkText = window.fulfillmentStrings.onlyShippingAbbr;
                }

                inventoryMarkup = ` 
                <quick-add-show-inventory data-variant-id="${variantId}">
                  <button
                    type="button"
                    class="group cursor-pointer flex items-center text-left flex-wrap">
                    <span class="flex items-center">
                      ${this.inStockIcon}
                      ${totalQty.toLocaleString('en-US')} in stock
                    </span>
                    <span class="px-1">|</span>
                    <span
                      class="
                        font-bold text-primary-500 group-hover:text-primary-600 group-focus:text-primary-600
                        group-hover:underline group-focus:underline">${inventoryLinkText}</span>
                  </button>
                </quick-add-show-inventory>`;
              } else {
                inventoryMarkup = `${this.outOfStockIcon} <span>${window.fulfillmentStrings.outOfStock}</span>`;
              }
            }
          } else {
            this.jsonInventory = null;
            inventoryMarkup = this.inventoryOriginalHtml;
          }

          inventoryElements.forEach((element) => {
            element.innerHTML = inventoryMarkup;
          });
        })
        .catch((e) => {
          console.log('error fetching inventory', e);
          inventoryMarkup = this.inventoryOriginalHtml;
        });

      /*
      

      if (inventory !== null) {
        if (inventory > 0) {
          inventoryMarkup = `${this.inStockIcon} <span>${inventory.toLocaleString('en-US')} in stock</span>`;
        } else {
          inventoryMarkup = `${this.outOfStockIcon} <span>Out of stock</span>`;
        }
      } else {
        
      }

      inventoryElements.forEach((element) => {
        element.innerHTML = inventoryMarkup;
      });*/
    }
  }

  customElements.define('quick-add', QuickAdd);
}

//create the quick-add-show-inventory class and customElement

class QuickAddShowInventory extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.modalLoading = '';
    this.addEventListener('click', this.handleClick.bind(this));
  }

  renderModalContent(sectionInnerHTML, modalContainer) {
    modalContainer.innerHTML = sectionInnerHTML.innerHTML;

    const jsonData =
      this.closest('quick-add') && this.closest('quick-add').jsonInventory
        ? this.closest('quick-add').jsonInventory
        : null;

    if (!jsonData) {
      console.log('no json data');
      return;
    }

    const qtyAvailableDisplay = modalContainer.querySelector('.quantities-available-display');
    const fulfillmentOptionSummary = modalContainer.querySelector('.fulfillment-option-summary');
    let totalQuantity = 0,
      shipQuantity = 0,
      pickupQuantity = 0;

    jsonData.forEach((entry) => {
      const locationQty = parseInt(entry.quantity, 10);
      totalQuantity += locationQty;
      const locationId = entry.location.id;
      const locationElement = document.querySelector(
        `.pickup-availability-list__item[data-location-id="${locationId}"]`
      );
      if (locationElement) {
        pickupQuantity += locationQty;
        if (locationQty > 0) {
          locationElement.querySelector('.item-available-info').innerHTML = `<span>${locationQty.toLocaleString(
            'en-US'
          )}</span> in stock`;
          locationElement.querySelector('.item-available').classList.remove('hidden');
          locationElement.querySelector('.item-unavailable').classList.add('hidden');
        } else {
          locationElement.querySelector('.item-available-info').innerHTML = `<span>${locationQty}</span> in stock`;
          locationElement.querySelector('.item-available').classList.add('hidden');
          locationElement.querySelector('.item-unavailable').classList.remove('hidden');
        }
      } else {
        console.log('location element not found');
      }
    });

    if (totalQuantity) {
      const updateQtyElements = modalContainer.querySelectorAll(`.inventory-total-quantity`);
      updateQtyElements.forEach((el) => (el.innerHTML = totalQuantity.toLocaleString('en-US')));
      shipQuantity = totalQuantity - pickupQuantity;

      if (shipQuantity > 0 && pickupQuantity > 0) {
        const pickupQtyElement = modalContainer.querySelector('.pickup-available-quantity');
        const shippingQtyElement = modalContainer.querySelector('.shipping-available-quantity');

        if (pickupQtyElement) {
          if (pickupQuantity > 0) {
            pickupQtyElement.innerHTML = pickupQuantity.toLocaleString('en-US');
            pickupQtyElement.closest('ul').classList.remove('hidden');
          }
        }
        if (shippingQtyElement) {
          if (shipQuantity > 0) {
            shippingQtyElement.innerHTML = shipQuantity.toLocaleString('en-US');
            shippingQtyElement.closest('ul').classList.remove('hidden');
          }
        }
        if (qtyAvailableDisplay) {
          qtyAvailableDisplay.classList.remove('hidden');
        }
      } else {
        console.log('some qty is 0');
        if (fulfillmentOptionSummary) {
          if (shipQuantity > 0) {
            fulfillmentOptionSummary.innerHTML = window.fulfillmentStrings.onlyShippingAvailable;
          } else if (pickupQuantity > 0) {
            fulfillmentOptionSummary.innerHTML = window.fulfillmentStrings.onlyPickupAvailable;
          } else {
            fulfillmentOptionSummary.innerHTML = '';
          }
        }

        if (qtyAvailableDisplay) {
          qtyAvailableDisplay.classList.add('hidden');
        }
      }
    }
  }

  handleClick() {
    if (!this.variantId) {
      return;
    }
    // Handle the click event for showing inventory details
    // Add your code here
    const modal = document.getElementById('product-card-stock-status');

    if (modal) {
      const modalContainer = modal.querySelector('#product-stock-status-wrapper');

      if (modalContainer.classList.contains('show-loading')) {
        window.stockModalLoadingHtml = modalContainer.innerHTML;
        modalContainer.classList.remove('show-loading');
      } else {
        modalContainer.innerHTML = window.stockModalLoadingHtml;
      }

      let rootUrl = Shopify.routes.root;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }

      // fetch the variant-stock-modal-content section with the variant id
      const variantSectionUrl = `${rootUrl}variants/${this.variantId}/?section_id=variant-stock-modal-content`;
      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
          this.renderModalContent(sectionInnerHTML, modalContainer);
        })
        .catch((e) => {
          console.log('error fetching inventory', e);
        });

      modal.open();
    } else {
      alert('Error: Inventory details not currently available.');
    }
  }
}

customElements.define('quick-add-show-inventory', QuickAddShowInventory);
